module.exports = __webpack_public_path__ + "img/校招岗位@2x.6f6c429d.png";